import React from 'react';

const PricingHero = () => {
  return (
    <section style={{ position: 'relative', padding: '140px 48px 80px', background: 'var(--color-background)', overflow: 'hidden' }}>
      {/* Geometric background accents */}
      <div style={{ position: 'absolute', top: '20%', right: '-100px', width: '400px', height: '400px', border: '1px solid rgba(0,79,152,0.08)', transform: 'rotate(25deg)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', top: '10%', right: '5%', width: '200px', height: '200px', border: '1px solid rgba(255,87,34,0.06)', transform: 'rotate(15deg)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '0', left: '-80px', width: '320px', height: '320px', border: '1px solid rgba(0,79,152,0.05)', transform: 'rotate(-20deg)', pointerEvents: 'none' }} />
      {/* Diagonal accent line */}
      <div style={{ position: 'absolute', top: 0, left: '30%', width: '1px', height: '100%', background: 'linear-gradient(to bottom, transparent, rgba(255,87,34,0.08), transparent)', pointerEvents: 'none' }} />
      <div style={{ maxWidth: '1440px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '80px' }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'inline-block', background: 'rgba(255,87,34,0.1)', border: '1px solid rgba(255,87,34,0.25)', borderRadius: '2px', padding: '4px 12px', marginBottom: '24px' }}>
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#FF5722' }}>Abonnement</span>
            </div>
            <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '56px', fontWeight: 700, color: 'var(--color-foreground)', lineHeight: 1.05, letterSpacing: '-0.02em', marginBottom: '24px' }}>
              Velg riktig plan
              <span style={{ display: 'block', color: '#FF5722' }}>for deg</span>
            </h1>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '17px', fontWeight: 400, color: 'var(--color-muted-foreground)', lineHeight: 1.7, maxWidth: '480px' }}>
              Ingen bindingstid. Spar penger på norske veier med Veiassistent. Oppgrader eller nedgrader når som helst.
            </p>
          </div>
          {/* Stats panel */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', minWidth: '260px' }}>
            {[
              { value: '10 000+', label: 'Aktive brukere' },
              { value: 'kr 2 400', label: 'Gjennomsnittlig sparing/år' },
              { value: '99.9%', label: 'Oppetid' },
            ]?.map(stat => (
              <div key={stat?.label} style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(224,228,232,0.08)', borderRadius: '2px', padding: '20px 24px', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, width: '3px', height: '100%', background: '#FF5722' }} />
                <div style={{ fontFamily: 'var(--font-heading)', fontSize: '28px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '-0.01em' }}>{stat?.value}</div>
                <div style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', fontWeight: 500, color: 'var(--color-muted-foreground)', letterSpacing: '0.06em', textTransform: 'uppercase', marginTop: '4px' }}>{stat?.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingHero;
